import HttpStatus from 'http-status';

export enum Errors {
  INVALID_POSTAL_CODE = HttpStatus.BAD_REQUEST,
}

interface ErrorPayload {
  [key: string]: string;
}

export interface ErrorResponse {
  status: number;
  data: ErrorPayload;
}
